import React, { useState } from 'react';
import { showAppAlert } from '../utils/alertService';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function AddCompanyModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    nomeFantasia: '',
    telefone: '',
    nomeResponsavel: '',
    urlLogo: null,
    valor_ponto: '',
    dias_ausencia: '',
    placeid: '',
    user_id: JSON.parse(localStorage.getItem('user')).id,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const qtd_companies = localStorage.getItem('qtd_companies') || 1;

    const payload = {
      nomeFantasia: formData.nomeFantasia,
      telefone: (formData.telefone || '').replace(/\D/g, ''),
      nomeResponsavel: formData.nomeResponsavel,
      urlLogo: formData.urlLogo || null,
      valor_ponto: parseFloat(formData.valor_ponto),
      dias_ausencia: parseInt(formData.dias_ausencia, 10),
      placeid: formData.placeid || null,
      status: 1,
      user_id: formData.user_id,
      qtd_companies: Number(qtd_companies),
    };

    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`${API_URL}/companies`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        showAppAlert('success', 'Cadastro realizado com sucesso!');
        onClose();
      } else if (response.status === 409) {
        const errorData = await response.json();
        showAppAlert('error', errorData.error);
      }
    } catch (error) {
      console.error('Erro ao enviar os dados:', error);
      showAppAlert('error', 'Erro ao realizar o cadastro. Tente novamente.');
    }
  };

  function maskCelular(value) {
    return value
      .replace(/\D/g, '')
      .replace(/^(\d{2})(\d)/g, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1');
  }

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content small-modal">
        <h3>Cadastro de Empresa</h3>
        <form onSubmit={handleSubmit}>
          {/* Nome Fantasia */}
          <label className="label-style">
            Nome Fantasia:
            <input
              type="text"
              name="nomeFantasia"
              value={formData.nomeFantasia}
              onChange={handleChange}
              className="input-style"
              required
            />
          </label>

          {/* Responsável */}
          <label className="label-style">
            Responsável:
            <input
              type="text"
              name="nomeResponsavel"
              value={formData.nomeResponsavel}
              onChange={handleChange}
              className="input-style"
              required
            />
          </label>

          {/* Telefone */}
          <label className="label-style">
            Celular:
            <input
              type="text"
              name="telefone"
              value={formData.telefone}
              onChange={e => setFormData({ ...formData, telefone: maskCelular(e.target.value) })}
              className="input-style"
              required
            />
          </label>

          {/* Logotipo */}
          <label className="label-style">
            Logotipo:
            <input
              type="text"
              name="urlLogo"
              value={formData.urlLogo || ''}
              onChange={handleChange}
              className="input-style"
            />
          </label>

          {/* Valor do Ponto */}
          <label className="label-style">
            Valor do Ponto:
            <input
              type="number"
              name="valor_ponto"
              value={formData.valor_ponto}
              onChange={handleChange}
              className="input-style"
              step="0.5"
              required
            />
          </label>

          {/* Dias de Ausência */}
          <label className="label-style">
            Dias de Ausência:
            <input
              type="number"
              name="dias_ausencia"
              value={formData.dias_ausencia}
              onChange={handleChange}
              className="input-style"
              required
            />
          </label>
          
          {/* Place ID */}
          <label className="label-style">
            Place ID:
            <input
              type="text"
              name="placeid"
              value={formData.placeid}
              onChange={handleChange}
              className="input-style"
            />
          </label>

          <div className="button-container">
            <button type="submit" className="button-style">Cadastrar</button>
            <button type="button" className="button-style cancel" onClick={onClose}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCompanyModal;